type WindowedPeriod = {
	startDate: Date;
	endDate: Date;
};

// Must match the periods `@offstreetparking/invoices` raises deductions for — comparing instants, not
// calendar dates, so a period ending one millisecond before the window opens stays out of it.
export const selectPeriodsInCollectionWindow = <TPeriod extends WindowedPeriod>({
	payPeriods,
	collectionStartDate,
	collectionEndDate,
}: {
	payPeriods: TPeriod[];
	collectionStartDate?: Date | null;
	collectionEndDate?: Date | null;
}): TPeriod[] =>
	payPeriods
		.filter(
			(period) =>
				(!collectionStartDate || period.endDate >= collectionStartDate) &&
				(!collectionEndDate || period.startDate <= collectionEndDate),
		)
		.sort((a, b) => a.startDate.getTime() - b.startDate.getTime());
